import { useMemo } from 'react';

import { useRewardPoolsActiveRafflesInfiniteQuery } from '@shared/hooks/query/rewardPools';

import RewardPoolsSlider from '../common/RewardPoolsSlider';
import { SegmentContainer } from './SegmentContainer';

export const ActiveRaffles = () => {
  const { data: featuredRewardPools } = useRewardPoolsActiveRafflesInfiniteQuery();

  const allRewardPools = useMemo(
    () => featuredRewardPools?.pages.flatMap((page) => page.pools) || [],
    [featuredRewardPools],
  );

  if (!allRewardPools.length) {
    return null;
  }

  return (
    <SegmentContainer title="Active Raffles">
      <RewardPoolsSlider rewardPools={allRewardPools} />
    </SegmentContainer>
  );
};
